import { SET_FORMAL_NOTICE } from './action-types';
import { CLEAR_FORMAL_NOTICE } from './action-types';

export const setFormalNotice = data => {
  return async dispatch => {
    dispatch({
      type: SET_FORMAL_NOTICE,
      data
    });
  };
};

export const clearFormalNotice = () => ({
  type: CLEAR_FORMAL_NOTICE
});



// WEBPACK FOOTER //
// ./src/actions/formalNotice-actions.js